import { useQuery } from "@tanstack/react-query";
import LoadingComponent from "../../LoadingComponent";
import { getPendingBarcodes } from "../../api/inventory-reports";
import CustomTable from "../common/CustomTable";
import {
  pendingBarcodesReportCols,
  pendingBarcodesTanotiReportCols,
} from "../../utils/table/inventoryReportCols";
import { Fragment, useMemo } from "react";
import { selectedBarcodeHistoryState } from "../../utils/atoms/atoms";
import { useSetRecoilState } from "recoil";

const PendingBarcodesReports = () => {
  const { data, isLoading, isError, isSuccess } = useQuery(
    ["pendingBarcodes"],
    getPendingBarcodes
  );

  const setSelectedBarcode = useSetRecoilState(selectedBarcodeHistoryState);

  const handleHistoryClick = (barcodeValue: string) => {
    setSelectedBarcode(barcodeValue);
  };

  const columns = useMemo(
    () =>
      process.env.REACT_APP_COMPANY_NAME === "TANOTI"
        ? pendingBarcodesTanotiReportCols(handleHistoryClick)
        : pendingBarcodesReportCols(handleHistoryClick),
    []
  );
  return (
    <LoadingComponent
      isLoading={isLoading}
      isError={isError}
      isSuccess={data}
      ComponentBody={
        <Fragment>
          <div className="h4 mt-2">Pending Barcodes Report</div>
          <CustomTable
            data={data || []}
            columns={columns}
            isFilter={true}
            isPaginate={true}
          />
        </Fragment>
      }
    />
  );
};

export default PendingBarcodesReports;
